module.exports = __webpack_public_path__ + "static/media/electro-mechanical.00bd07ed.svg";